export default __webpack_public_path__ + "static/media/pebble-red-narrow.05197c4e.svg";